import React, {PureComponent, HTMLAttributes, CSSProperties} from 'react'
import PropTypes from 'prop-types'
import Theme from 'Theme'
import cxs from 'cxs/component'

interface Props extends HTMLAttributes<HTMLSpanElement> {
  name: Iconos
  size?: number
  hover?: string
}

class IconosApp extends PureComponent<Props, Props> {
  render() {
    const {name, ...props} = this.props
    return <StyledIcon {...props}>{name}</StyledIcon>
  }
}

export default IconosApp

const StyledIcon = cxs('div')(
  ({size, color, hover}) =>
    ({
      display: 'inline-block',
      fontFamily: 'IconosApp',
      fontSize: size ? size + 'px' : Theme.fontSize.big,
      textTransform: 'initial',
      lineHeight: 1,
      padding: Theme.size.space[1],
      ':hover': {
        color: hover? hover: Theme.color.primary
      },
      color: color? color: Theme.color.secondary
    } as CSSProperties)
)

StyledIcon.propTypes = {
  size: PropTypes.number
}

type IconosType =
  | 'atraccion'
  | 'autobus'
  | 'avion'
  | 'barco'
  | 'bicicleta'
  | 'buceo'
  | 'bus'
  | 'busTuristico'
  | 'excursion'
  | 'funcion'
  | 'funicular'
  | 'helicopero'
  | 'hopOnOff'
  | 'ida-vuelta'
  | 'lancha'
  | 'moto'
  | 'motoAgua'
  | 'museo'
  | 'panoramica'
  | 'paradaBus'
  | 'ParadaTren'
  | 'parqueAtracciones'
  | 'patin'
  | 'ruta'
  | 'ticket'
  | 'tranvia'
  | 'trenecito'

export const Icono = {
 Atraccion : 'atraccion',
 Autobus : 'autobus',
 Avion : 'avion',
 Barco : 'barco',
 Bicicleta : 'bicicleta',
 Buceo : 'buceo',
 Bus : 'bus',
 BusTuristico : 'busTuristico',
 Excursion : 'excursion',
 Funcion : 'funcion',
 Funicular : 'funicular',
 Helicoptero : 'helicopero',
 HopOnOff : 'hopOnOff',
 IdaVuelta : 'idavuelta',
 Lancha : 'lancha',
 Moto : 'moto',
 MotoAgua : 'motoAgua',
 Museo : 'museo',
 Panoramica : 'panoramica',
 ParadaBus : 'busParada',
 ParadaTren : 'trenParada',
 ParqueAtracciones : 'parqueAtracciones',
 Patin : 'patin',
 Ruta : 'ruta',
 Ticket : 'ticket',
 Tranvia : 'tranvia',
 Trenecito : 'trenecito',
}

export type Iconos = string

export const Iconos = Object.keys(Icono)/*.map(value => {
  console.log('value: ', value)
  return value
})*/



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/IconosApp.tsx